export var DataSourceType;
(function (DataSourceType) {
    DataSourceType[DataSourceType["FBox"] = 1] = "FBox";
})(DataSourceType || (DataSourceType = {}));
